import React,{useState,useEffect}  from 'react'
import {Box,Typography,Container,Grid,Paper,Button, FormControlLabel, Radio, RadioGroup, FormLabel} from '@mui/material'
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import {IconButton} from "@mui/material"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import useMediaQuery from '@mui/material/useMediaQuery'; 
import UserInput from '../Components/UserInput'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import GridViewContainer from '../Components/GridViewContainer';
import AutoInput from '../Components/AutoInput';
import MultiInput from '../Components/MultiInput';
import { MicRounded,FormatAlignCenter, FileOpen, Remove } from '@mui/icons-material';
import { add_activities,add_activity } from '../Redux/settingSlice';
import BenefitsDialog from '../Components/BenefitsDialog';
import EligibleDialog from '../Components/EligibleDialog';
import QuestionsDialog from '../Components/QuestionsDialog';
import { FileUploader } from 'react-drag-drop-files';
import edit_job from '../Redux/reducers/edit_job';
import EditorText from '../Components/EditorText';

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'hidden',
overflowX: 'hidden'
})
);

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
return <Typography  style={{fontWeight:500,fontSize:11,color:'white'}}> {displayText} </Typography>
}

const EditJob = ()=>{

	const locations= ["On-site","Remote","Hybrid"]
	const categories= ["Full-time","Part-time","Contract"]
	const types = ["Job","Internship","Voluntarism"]

	const theme = useTheme()
    const job = useSelector(state => state?.job.job);
	const [code,setCode] = useState("")
	const [name,setName] = useState(job?.enterprise_name)
	const [title,setTitle] = useState(job?.title)
	const [email,setEmail] = useState("")
	const [description, setDescription] = useState(job?.description);
	const [o_description, setO_description] = useState(job?.enterprise_description);
	const [describe, setDescribe] = useState("");
	const [isValid, setIsValid] = useState(false);
	const [logoUrl, setLogoUrl] = useState(job?.enterprise_logo);
	const [docUrl, setDocUrl] = useState(job?.documents);
	const [showBenModal, setShowBenModal] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [showElModal, setShowElModal] = useState(false);
	const [type, setType] = useState(job?.type);
    const [deadline, setDeadline] = React.useState(job?.deadline);
	const navigate = useNavigate()
	const [file, setFile] = useState(job?.enterprise_logo);
	const [files, setFiles] = useState(job?.documents);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [category, setCategory] = React.useState(job?.category);
	const [location, setLocation] = React.useState(job?.location);
	const [isInfo, setIsInfo] = React.useState(true);
	const [hasAss, setHasAss] = React.useState(false);
	const [isSend, setIsSend] = React.useState(false);
	const [isLogoUploaded, setIsLogoUploaded] = React.useState(true);
	const [isDocUploaded, setIsDocUploaded] = React.useState(true);
	const [message, setMessage] = React.useState("");
	const [o_email, setO_email] = React.useState(job?.enterprise_email);
	const [link, setLink] = React.useState(job?.enterprise_link);
	const [benefits, setBenefits] = React.useState(job?.benefits);
	const [tel, setTel] = React.useState(job?.enterprise_tel);
	const [eligibilities, setEligibilities] = React.useState(job?.eligibilities);
	const [benefit, setBenefit] = React.useState("");
	const [eligibility, setEligibility] = React.useState("");
	const [field, setField] = React.useState(job?.field);
	const [question_type, setQuestion_type] = React.useState("Simple");
	const [choices, setChoices] = React.useState([]);
	const [maxLength, setMaxLength] = React.useState(200);
	const [content, setContent] = React.useState(job?.questions);
	const [isRequired, setIsRequired] = React.useState(false);
	const [isCv, setIsCv] = React.useState(false);
	const [choice, setChoice] = React.useState('');
	const user = useSelector(state => state?.auth.user);
	const jobs = useSelector(state => state?.job.jobs);
	const recorder = React.useRef(null)
	const [uploading, setUploading] = React.useState(false)
	const [isChecking, setIsChecking] = React.useState(false)
	const [deleting, setDeleting] = React.useState(false)
	const dispatch = useDispatch()
	const fileTypes = ["JPG","JPEG", "PNG"] 
	const docTypes = ["PDF"] 

async function handleUploadFile(data,isLog){
	try {

		setUploading(true)

		let formData = new FormData()

		formData.append("file",data)

		const upload = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/data/file/upload/`,formData,{
			headers:{
				"Content-Type":"multipart/form-data",
				"Authorization":`Bear ${user?.accessToken}`
			}
		}).catch(err=>{
			setMessage("Error while uploading")
			setOpen(true)
			setUploading(false)
			console.log(err)
		})

		if (upload?.status == 200 && upload?.data?.success) {
			if (isLog) {
				setLogoUrl(upload?.data?.url)
				setIsLogoUploaded(true)
				// setFile(null)
			} else {
				setDocUrl(upload?.data?.url)
				setIsDocUploaded(true)
				// setFiles(null)
			}
			setMessage("file uploaded on the server")
			setOpen(true)
			setUploading(false)
			// setUploaded(true)
		} else {
			setMessage(upload?.data?.message)
			setOpen(true)
			setUploading(false)
		}
		
	} catch (error) {
		console.log(error)
		setUploading(false)
	}
}
	
	async function handleDeleteFile(url,isLog){
		try {
	
			setDeleting(true)
	
			const data = {
				url:url
			} 
	
			const upload = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}/delete-file`,data,{
				headers:{
					"Content-Type":"application/json",
					"Authorization":`Bear ${user?.accessToken}`
				}
			}).catch(err=>{
				setMessage("Error while deleting")
				setOpen(true)
				setDeleting(false)
				console.log(err)
			})
	
			if (upload?.status == 200 && upload?.data?.success) {
				if (isLog) {
					setLogoUrl(null)
					setFile(null)
					setIsLogoUploaded(false)
					setFile(null)
				} else {
					setDocUrl(null)
					setFiles(null)
					setIsDocUploaded(false)
					setFiles(null)
				}
				setMessage(upload?.data?.message)
				setOpen(true)
				setDeleting(false)
				// setUploaded(false)
			} else {
				setMessage(upload?.data?.message)
				setOpen(true)
				setDeleting(false)
			}
			
		} catch (error) {
			console.log(error)
			setDeleting(false)
		}
	}

const handleAddChoice = async ()=>{
	try {
		if (choice !== null) {
			setChoices(prev=>[...prev,choice])
			setChoice("")
		} else {
			setMessage("Please your choice for selection")
			setOpen(true)
		}
	} catch (error) {
		console.log(error)
	}
}

const handleDelete = async (item)=>{
	try {

		const data = content?.filter(itm=>itm?.content !== item?.content)
		console.log(item)
		setContent(data)

	} catch (error) {
		console.log(error)
	}
}

const handleAdd = async ()=>{
	try {
		if (describe !== "") {
			const data = {
				type:question_type,
				content:describe,
				isRequired:isRequired,
				isCv:question_type === "Files" ? isCv : false,
				maxLength:question_type === "Simple" ? maxLength : 200,
				choices:(question_type === "Multiple" || question_type === "One") ? choices : []
			}

			setContent(prev=>[...prev,data])
			setQuestion_type("Simple")
			setChoices([])
			setMaxLength(200)
			setDescribe("")

		} else {
			setMessage("Please your question content")
			setOpen(true)
		}
	} catch (error) {
		console.log(error)
	}
}

const handleValid = async ()=>{
	try {
		setIsChecking(true)

		const data = {
			code:code,
			email:user?.email
		}
	
		const checkTest = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}valid-test/`,data,{
			headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
		}).catch(err=>{
			setMessage("Error while checking")
			setOpen(true)
			setIsChecking(false)
			console.log(err)
		})
	
		if (checkTest?.status == 200 && checkTest?.data?.success) {
			setMessage("file uploaded on the server")
			setOpen(true)
			setIsChecking(false)
			setIsValid(true)
		} else {
			setMessage(checkTest?.data?.message)
			setOpen(true)
			setIsChecking(false)
		}
	} catch (error) {
		console.log(error)
	}
}


const handleCreate = async ()=>{
	try{
		if (isInfo) {
			if (name !== '' && description !== ''  && field !== '') {
				setIsInfo(false)
				setIsSend(true)
			} else {
				setMessage("please, fill all the form")
				setOpen(true)
			}
		} else{
			if (content?.length > 0) {
				if ((file !== null && logoUrl !== "") || (files !== null && docUrl !== "")) {
					if (hasAss) {
						if (code !== "" && isValid) {
							const send_data = {
								id:job?.id,
								name:name,
								title:title,
								type:type,
								category:category,
								location:location,
								owner:user?.email,
								enter_email:o_email,
								description:description,
								deadline:deadline,
                                applicants:job?.applicants || [],
                                unmatched:job?.unmatched || [],
								field:field,
								link:link,
								logo:logoUrl ? logoUrl : null,
								enter_description:o_description,
								eligible:eligibilities,
								documents:docUrl ? docUrl : null,
								benefits:benefits,
								content:content,
								code:hasAss ? code : null,
								hasAss:hasAss
							}
				
							const token = user?.accessToken
				
							edit_job(token,jobs,dispatch,setOpen,setMessage,send_data,setLoading,navigate)
				
						}else{
							setMessage("please,valid if the assessment really exists or select non to continue")
							setOpen(true)
						}
					} else {
						const send_data = {
							id:job?.id,
							name:name,
							title:title,
							type:type,
							category:category,
							owner:user?.email,
							enter_email:o_email,
							description:description,
							location:location,
							deadline:deadline,
                            applicants:job?.applicants || [],
                            unmatched:job?.unmatched || [],
							field:field,
							link:link,
							logo:logoUrl ? logoUrl : null,
							enter_description:o_description,
							eligible:eligibilities,
							documents:docUrl ? docUrl : null,
							benefits:benefits,
							content:content,
							code:hasAss ? code : null,
							hasAss:hasAss
						}
			
						const token = user?.accessToken
			
						edit_job(token,jobs,dispatch,setOpen,setMessage,send_data,setLoading,navigate)
			
					}
				} else {
					setMessage("please, upload your files before to post a job")
					setOpen(true)
				}
			} else {
				setMessage("please, add content detail")
				setOpen(true)
			}
		}

	}catch(err){
		console.log(err)
	}
}

async function addData (newData){
	const getData = await localStorage.getItem("activities")

	if(getData){
		const parseData = JSON.parse(getData)

		if (parseData.length === 4) {
			const updatedData = [...parseData.slice(1), newData]; 
			dispatch(add_activities(updatedData))
			dispatch(add_activity(newData))
			localStorage.setItem("activities",JSON.stringify(updatedData))
		} else { 
			dispatch(add_activities([newData, ...JSON.parse(getData)]))
			dispatch(add_activity(newData))
			localStorage.setItem("activities",JSON.stringify([newData, ...parseData]))
		}
	}else{
		dispatch(add_activities([newData]))
		localStorage.setItem("activities",JSON.stringify([newData]))
	}
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

	return(
		<ContainerBox>
			<Header title="Post a Job">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Edit/Offer</Typography>
			</Breadcrumbs>			
			</Header>
			<Container sx={{marginLeft:-5}}>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<ContainerBox m={2} sx={{backgroundColor:"black",borderRadius:5,padding:2,width:'100%'}}>
					<Box m={1} display="flex" flexWrap="wrap" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography mt={1} mb={1} style={{fontSize:18,fontWeight:400,fontFamily:"dinofans"}}>
							Edit Offer Detail
						</Typography>
						{
						isSend && (
							<Box>
								<IconButton sx={{borderRadius:2,height:25}} onClick={()=>{
									setShowModal(true)
								}}>
									<Typography>
										{content?.length}
									</Typography>
									<FileOpen />
								</IconButton>
								<IconButton sx={{borderRadius:2,height:25}} onClick={()=>{
									if(isSend){
										setIsSend(false)
										setIsInfo(true)
									}else{
										setIsSend(true)
										setIsInfo(false)
									}
								}}>
									<ArrowIcon />
								</IconButton>
							</Box>
						)}
					</Box>
					{isInfo && (
						<GridViewContainer>
							<Box m={1} sx={{width:"100%"}}>
								<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}}>Offer detail </Typography>
							</Box>
							<UserInput
								label="Title *"
								isPass={false}
								input={title}
								setInput={setTitle}
							>
								<FormatAlignCenter/>
							</UserInput>
							<UserInput
								label="Field *"
								input={field}
								isDes={false}
								isPass={false}
								setInput={setField}
							>
								<FormatAlignCenter/>
							</UserInput>
                            <AutoInput
								data={types}
								setInput={setType}
								input={type}
								label="Type"
							/>
							<AutoInput
								data={locations}
								setInput={setLocation}
								input={location}
								label="Location"
							/>
							<AutoInput
								data={categories}
								setInput={setCategory}
								input={category}
								label="Category"
							/>
							<UserInput
								label="Deadline *"
								input={deadline}
								isDate={true}
								isPass={false}
								setInput={setDeadline}
							>
								<FormatAlignCenter/>
							</UserInput>
							<Box width="80%">
								<EditorText 
									title="Offer description"
									data={description}
									setData={setDescription}
									width="95%"
									label="description"
									isRequired={true}
								/>
							</Box>
							<Box m={1} sx={{width:"100%"}}>
								<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}}>More detail </Typography>
							</Box>
							{
								benefits?.length > 0 && (
									<Box m={1} ml={2}  sx={{width:"calc(45%)"}}>
										<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}}>Benefits </Typography>
										{
											benefits?.map((itm,index)=>(
												<Box key={index} display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" width="100%">
													<DescriptionText text={`${index+1}.  ${itm}`} limit={40}/>
													<IconButton onClick={(e)=>{
														e?.preventDefault()
														const data = benefits?.filter(item=>item !== itm)
														setBenefits(data)
													}}>
														<Remove sx={{color:"gold"}}/>
													</IconButton>
												</Box>
											))
										}
									</Box>
								)
							}
							{
								eligibilities?.length > 0 && (
									<Box m={1} ml={2} mt={1} sx={{width:"calc(45%)"}}>
										<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}}>Eligibilities </Typography>
										{
											eligibilities?.map((itm,index)=>(
												<Box key={index} display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" width="100%">
													<DescriptionText text={`${index+1}.  ${itm}`} limit={40}/>
													<IconButton onClick={(e)=>{
														e?.preventDefault()
														const data = eligibilities?.filter(item=>item !== itm)
														setEligibilities(data)
													}}>
														<Remove sx={{color:"gold"}}/>
													</IconButton>
												</Box>

											))
										}
									</Box>
								)
							}
							<Box sx={{width:"100%",mt:2}} display="flex" flexWrap="wrap" flexDirection="row" justifyContent="flex-start" alignItems="center">
								<Button  onClick={()=>{
									setShowBenModal(true)
								}} sx={{background:"gold",color:"#000",margin:1,fontSize:12,fontFamily:"dinofans"}} variant="contained">
									Add Benefits
								</Button>
								<Button  onClick={()=>{
									setShowElModal(true)
								}} sx={{background:"gold",color:"#000",margin:1,fontSize:12,fontFamily:"dinofans"}} variant="contained">
									Add eligibility
								</Button>
							</Box>
							<Box m={1} sx={{width:"100%"}}>
								<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}}>Enterprise detail </Typography>
							</Box>
							<UserInput
								label="Organization *"
								input={name}
								isDes={false}
								isPass={false}
								setInput={setName}
							>
								<FormatAlignCenter/>
							</UserInput>
							<UserInput
								label="Email*"
								input={o_email}
								isDes={false}
								isPass={false}
								setInput={setO_email}
							>
								<FormatAlignCenter/>
							</UserInput>
							<UserInput
								label="Tel*"
								input={tel}
								isDes={false}
								isPass={false}
								setInput={setTel}
							>
								<FormatAlignCenter/>
							</UserInput>
							<MultiInput
								label="Website/ Social link"
								input={link}
								isPass={false}
								setInput={setLink}
							>
								<FormatAlignCenter/>
							</MultiInput>
							<Box width="95%">
								<EditorText 
									title="Organization description"
									data={o_description}
									setData={setO_description}
									width="95%"
									label="description"
									isRequired={true}
								/>
							</Box>
						</GridViewContainer>
						)
					}
					{isSend && (
						<GridViewContainer>
							<Box m={1} sx={{width:"100%"}}>
								<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}}>Form questions</Typography>
							</Box>
							<Box ml={2} sx={{width:"100%"}}>
								<Box width="80%">
									<EditorText 
										title="Question description"
										data={describe}
										setData={setDescribe}
										width="95%"
										label="description"
										isRequired={true}
									/>
								</Box>
								<Divider sx={{mt:2,mb:2}}/>
								<FormControl>
									<FormLabel sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}} id="demo-row-radio-buttons-group-label">Input required</FormLabel>
									<RadioGroup
										value={isRequired ? "Yes" : "Non"}
										row
										aria-labelledby="demo-row-radio-buttons-group-label"
										name="row-radio-buttons-group"
										sx={{ml:2,width:"100%",flexWrap:"wrap"}}
									>
										<FormControlLabel  value="Yes" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setIsRequired(true)
											}} />} label={<Typography  sx={{fontSize:12}}>Yes</Typography>} />
										<FormControlLabel  value="Non" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setIsRequired(false)
											}} />} label={<Typography  sx={{fontSize:12}}>Non</Typography>} />
									</RadioGroup>
								</FormControl>
							</Box>
							<Box ml={2} mt={1} justifyContent="center" alignItems="center" width="100%">
								<FormControl>
									<FormLabel sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}} id="demo-row-radio-buttons-group-label">Input type</FormLabel>
									<RadioGroup
										value={question_type}
										row
										aria-labelledby="demo-row-radio-buttons-group-label"
										name="row-radio-buttons-group"
										sx={{ml:2,width:"100%",flexWrap:"wrap"}}
									>
										<FormControlLabel  value="Simple" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setQuestion_type("Simple")
											}} />} label={<Typography  sx={{fontSize:12}}>Simple</Typography>}/>
										<FormControlLabel value="Image" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setQuestion_type("Image")
											}} />} label={<Typography  sx={{fontSize:12}}>Image</Typography>} />
										<FormControlLabel value="Files" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setQuestion_type("Files")
											}} />} label={<Typography  sx={{fontSize:12}}>Files</Typography>}/>
										<FormControlLabel value="Link" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setQuestion_type("Link")
											}} />} label={<Typography  sx={{fontSize:12}}>Link</Typography>} />
										<FormControlLabel value="Multiple" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setQuestion_type("Multiple")
										}} />} label={<Typography  sx={{fontSize:12}}>Multiple</Typography>} />
										<FormControlLabel value="One" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
												setQuestion_type("One")
										}} />} label={<Typography  sx={{fontSize:12}}>Single choice</Typography>} />
									</RadioGroup>
								</FormControl>
							</Box>
							{(question_type === "Files") && (
								<Box ml={3} mt={1} justifyContent="center" alignItems="center" width="100%">
									<FormControl>
										<FormLabel sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}} id="demo-row-radio-buttons-group-label">Is it a CV ?</FormLabel>
										<RadioGroup
											row
											aria-labelledby="demo-row-radio-buttons-group-label"
											name="row-radio-buttons-group"
											sx={{ml:2,width:"100%",flexWrap:"wrap"}}
										>
											<FormControlLabel  value="Non" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
													setIsCv(false)
												}} />} label={<Typography  sx={{fontSize:12}}>Non</Typography>} />
											<FormControlLabel value="Yes" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
													setIsCv(true)
												}} />} label={<Typography  sx={{fontSize:12}}>Yes</Typography>} />
										</RadioGroup>
									</FormControl>
								</Box>
								)
							}
							{
								(question_type === "Simple") && (
									<Box ml={3}>
										<UserInput
											label="Input length *"
											input={maxLength}
											isPass={false}
											setInput={setMaxLength}
										>
											<FormatAlignCenter/>
										</UserInput>
										<Divider sx={{mt:2}}/>
									</Box>
								)
							}
							{
								(question_type === "Multiple" || question_type === "One") && (
									<Box ml={5}>
										<MultiInput
											label="add a choice *"
											input={choice}
											isPass={false}
											setInput={setChoice}
										>
											<FormatAlignCenter/>
										</MultiInput>
										<Button  onClick={handleAddChoice} sx={{background:"#fff",color:"maroon",fontFamily:"dinofans",fontSize:11}}  variant="contained">
											Add
										</Button>
										<Divider sx={{mt:2}}/>
									</Box>
								)
							}
						</GridViewContainer>
						)}
						{
							isSend && (
								<Box m={2}>
									<Button  onClick={handleAdd} sx={{background:"gold",color:"#000",fontFamily:"dinofans",fontSize:11}} variant="contained">
										Add
									</Button>
								</Box>
							)
						}
						<Divider sx={{mt:3}}/>
						{
							isSend && (
								<>
									<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold",m:2}}>Organization logo </Typography>
									<Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
										<FileUploader onDrop={(file)=>{setFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
											setFile(file)
										}} name="file" types={fileTypes} />
									</Box>
									{
										file !== null && (
											<Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
												<Button disabled={uploading || isLogoUploaded} onClick={(e)=>{
													e?.preventDefault()
													handleUploadFile(file,true)
												}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
													Upload
												</Button>
												{
													isLogoUploaded && (
														<Button disabled={deleting} onClick={(e)=>{
															e?.preventDefault()
															handleDeleteFile(logoUrl,true)
														}}  sx={{background:"maroon",color:"#fff",fontFamily:"dinofans",fontSize:10}} variant="contained">
															Delete
														</Button>
													)
												}
											</Box>
										)
									}
									<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"gold",m:2}}>Others Documents</Typography>
									<Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
										<FileUploader onDrop={(file)=>{setFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
											setFiles(file)
										}} name="files" types={docTypes} />
									</Box>
									{
										files !== null && (
											<Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
												<Button disabled={uploading || isDocUploaded} onClick={(e)=>{
													e?.preventDefault()
													handleUploadFile(files,false)
												}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
													Upload
												</Button>
												{
													isDocUploaded && (
														<Button disabled={deleting} onClick={(e)=>{
															e?.preventDefault()
															handleDeleteFile(docUrl,false)
														}}  sx={{background:"maroon",color:"#fff",fontFamily:"dinofans",fontSize:10}} variant="contained">
															Delete
														</Button>
													)
												}
											</Box>
										)
									}
									<Divider sx={{mt:3}}/>
									<Box ml={2} mt={1} justifyContent="center" alignItems="center" width="100%">
										<FormControl>
											<FormLabel sx={{fontSize:13,color:"#fff"}} id="demo-row-radio-buttons-group-label">Have you already created an assessment</FormLabel>
											<RadioGroup
												row
												aria-labelledby="demo-row-radio-buttons-group-label"
												name="row-radio-buttons-group"
												sx={{ml:2,width:"100%",flexWrap:"wrap"}}
											>
												<FormControlLabel  value="Non" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
														setHasAss(false)
													}} />} label={<Typography  sx={{fontSize:12}}>Non</Typography>} />
												<FormControlLabel value="Yes" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
														setHasAss(true)
													}} />} label={<Typography  sx={{fontSize:12}}>Yes</Typography>} />
											</RadioGroup>
										</FormControl>
									</Box>
									{
										hasAss && (
											<Box>
												<UserInput
													label="Code *"
													input={code}
													isDes={false}
													isPass={false}
													setInput={setCode}
												>
													<FormatAlignCenter/>
												</UserInput>
												<Button disabled={isValid || isChecking}  onClick={handleValid} sx={{background:"#fff",color:"maroon",fontFamily:"dinofans",fontSize:11}}  variant="contained">
													Valid
												</Button>
											</Box>
										)
									}
									<Divider sx={{mt:3}}/>
								</>
							)
						}
						<Box mt={2}>
							<Button disabled={loading ? true : false} onClick={handleCreate} sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:12}} variant="contained">
								{
									isSend && loading ? <CircularProgress size={20} style={{color:"gold"}}/> : isSend && !loading  ? "EDIT" : "NEXT"
								}
							</Button>
						</Box>
				</ContainerBox>
				{/* <CustomDialog data={participants} visible={showDialog} setVisible={setShowDialog}/> */}
				<BenefitsDialog handleAdd={()=>{
						setBenefits(prev=>[...prev,benefit])
						setBenefit("")
					}} benefit={benefit} setBenefit={setBenefit} visible={showBenModal} setVisible={setShowBenModal}/>
				<EligibleDialog handleAdd={()=>{
						setEligibilities(prev=>[...prev,eligibility])
						setEligibility("")
					}} eligible={eligibility} setEligible={setEligibility} visible={showElModal} setVisible={setShowElModal}/>	
					<QuestionsDialog setVisible={setShowModal} visible={showModal} handleDelete={handleDelete} data={content}/>
			</Container>
		</ContainerBox>
		)
}

export default EditJob